const tabImageIconMap: { [key: string]: string } = {
    "Profile": "user",
    "Home": "home",
    "Dashboard": "line-chart",
    "Share": "users",
    "Timeline": "newspaper-o",
    "Tasks": "calendar-check-o",
    "Messaging": "comments"
}
export default tabImageIconMap;